import { useEffect } from 'react';

const PromptPassword = () => {
  useEffect(() => {
    const { ApperUI } = window.ApperSDK;
    ApperUI.showPromptPassword('#authentication-prompt-password');
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-primary">
      <div className="py-12 px-5 flex justify-center items-center">
        <div id="authentication-prompt-password" className="glass-card mx-auto w-[400px] max-w-full p-10 rounded-card"></div>
      </div>
    </div>
  );
};

export default PromptPassword;